module.exports = __webpack_public_path__ + "static/media/Meadow.4036df23.mp3";